import { BulkSignOrchestratorApiTypes } from "@rshbintech.dboul/http";
import { SignedDocument } from "../types";
import {
  DOCUMENT_SIGNING_STAGES,
  DOCUMENT_SIGNING_STATUSES,
} from "../constants";

export const getDocumentsToCheckStatuses = (
  documents: SignedDocument[]
): BulkSignOrchestratorApiTypes.DocumentsStatusReq[] =>
  documents
    .filter(
      (document) =>
        document.status !== DOCUMENT_SIGNING_STATUSES.SUCCESS &&
        document.documentStatus.status !== DOCUMENT_SIGNING_STATUSES.ERROR &&
        document.documentStatus.status !== DOCUMENT_SIGNING_STATUSES.SUCCESS &&
        !document.signatureInfo.error &&
        document.signatureInfo.signingStage ===
          DOCUMENT_SIGNING_STAGES.SIGNATURE_IS_CHECKING
    )
    .map((document) => ({
      id: document.id,
      type: document.type.code,
      system: document.systemShortName,
    }));
